import type { PilotId } from '~/types/PilotId';

import type { FieldId } from './types/FieldId';

const UF_CLIENT_FIELD_ID_PATTERN =
  /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

export function isLegacyPilotFieldId(id: FieldId | null | undefined): boolean {
  if (id == null) {
    return false;
  }

  if (typeof id === 'number') {
    return true;
  }

  return /^\d+$/.test(id);
}

export function isUfClientFieldId(id: FieldId | null | undefined): boolean {
  if (id == null || typeof id === 'number') {
    return false;
  }

  return UF_CLIENT_FIELD_ID_PATTERN.test(id);
}

export function toLegacyPilotFieldId(id: FieldId): PilotId | null {
  if (typeof id === 'number') {
    return id;
  }

  if (/^\d+$/.test(id)) {
    return Number(id);
  }

  return null;
}

export function parseFieldId(id: string): FieldId {
  const legacyFieldId = toLegacyPilotFieldId(id);
  return legacyFieldId ?? id;
}

export function shouldResolveFieldViaUnifiedFields(
  isUnifiedFieldsM2Enabled: boolean,
  id: FieldId | null | undefined,
): boolean {
  return isUnifiedFieldsM2Enabled && isUfClientFieldId(id);
}
